import "@/App.css";
import "leaflet/dist/leaflet.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import Overview from "@/pages/Overview";
import Tracks from "@/pages/Tracks";
import Prospects from "@/pages/Prospects";
import Drafts from "@/pages/Drafts";
import Followups from "@/pages/Followups";
import Suppression from "@/pages/Suppression";
import Runs from "@/pages/Runs";
import Settings from "@/pages/Settings";
import Outlook from "@/pages/Outlook";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="grid min-h-screen place-items-center text-muted-foreground" data-testid="auth-loading">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected><AppShell /></Protected>}>
            <Route path="/" element={<Navigate to="/overview" replace />} />
            <Route path="/overview" element={<Overview />} />
            <Route path="/tracks" element={<Tracks />} />
            <Route path="/prospects" element={<Prospects />} />
            <Route path="/drafts" element={<Drafts />} />
            <Route path="/followups" element={<Followups />} />
            <Route path="/suppression" element={<Suppression />} />
            <Route path="/research-runs" element={<Runs />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/outlook" element={<Outlook />} />
          </Route>
          <Route path="*" element={<Navigate to="/overview" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="light" position="top-right" offset={76} richColors />
    </AuthProvider>
  );
}

export default App;
